import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { formatDateTime } from '../../utils/date-utils';

const Roadmap = ({ roadmap }) => {
  if (roadmap && !roadmap.fileName) {
    // The roadmap was synced, and is missing.
    return null;
  }
  const disabled = !roadmap || roadmap.loading || roadmap.updating;
  const isUpdated = roadmap && roadmap.isUpdated;
  return (
    <div>
      <div className="encart-roadmap">
        <Link
          className="btn btn-roadmap btn-block-sm"
          disabled={disabled}
          to="/roadmap">
          FEUILLE DE ROUTE
        </Link>
        {isUpdated && <span className="maj">Mise à jour le {formatDateTime(roadmap.audit.updateDateTime)}</span>}
      </div>
    </div>
  );
};

const selector = ({ roadmap: { data: roadmap } }) => ({ roadmap });

export default connect(selector)(Roadmap);



// WEBPACK FOOTER //
// ./book/src/commons/components/roadmap/Roadmap.jsx